'use client'
import { SbBlokData, storyblokEditable, StoryblokServerComponent } from '@storyblok/react/rsc'
import { FC } from 'react'

import { PhnxCalculator } from './Calculator'

interface CalculatorBlokProps {
  blok: {
    header: any
    calculator: any
    confirmation: SbBlokData[]
    howitscalculated: SbBlokData[]
    ratings: SbBlokData[]
    intro: SbBlokData[]
    resultsKey: any
    disclaimer: SbBlokData[]
  } & SbBlokData
}

const Calculator: FC<CalculatorBlokProps> = ({ blok }) => {
  return (
    <div {...storyblokEditable(blok)}>
      <PhnxCalculator
        headerTitle={blok.header[0].title}
        headerSubtitle={blok.header[0].subtitle}
        headerDescription={
          blok.header[0].description &&
          blok.header[0].description.map((nestedBlok: SbBlokData) => (
            <StoryblokServerComponent blok={nestedBlok} key={nestedBlok._uid} />
          ))
        }
        headerSubbanner={
          blok.header[0].subBannerContent &&
          blok.header[0].subBannerContent.map((nestedBlok: SbBlokData) => (
            <StoryblokServerComponent blok={nestedBlok} key={nestedBlok._uid} />
          ))
        }
        headerAsset={
          blok.header[0].asset
            ? {
                src: blok.header[0].asset.filename,
                alt: blok.header[0].asset.alt,
                focus: blok.header[0].asset.focus,
                wash_opacity: blok.header[0].washOpacity ? blok.header[0].washOpacity : 0,
              }
            : undefined
        }
        calcFormFields={blok.calculator[0].calcFormFields?.map((nestedBlok: SbBlokData) => ({
          ...nestedBlok,
        }))}
        ratings={
          blok.calculator[0].ratings &&
          blok.calculator[0].ratings
            .map((nestedBlok: SbBlokData) => {
              const { low = {}, medium = {}, high = {}, _uid, type } = nestedBlok // Access directly from nestedBlok
              return { component: 'calcFormRating', high, low, medium, type, _uid }
            })
            .filter(Boolean)
        }
        confirmationMessage={
          blok.confirmation &&
          blok.confirmation.map((nestedBlok: SbBlokData) => (
            <StoryblokServerComponent blok={nestedBlok} key={nestedBlok._uid} />
          ))
        }
        intro={
          blok.intro &&
          blok.intro.map((nestedBlok: SbBlokData) => (
            <StoryblokServerComponent blok={nestedBlok} key={nestedBlok._uid} />
          ))
        }
        resultsKey={
          blok.resultsKey &&
          blok.resultsKey.map((nestedBlok: SbBlokData) => (
            <StoryblokServerComponent blok={nestedBlok} key={nestedBlok._uid} />
          ))
        }
        howitscalculated={
          blok.howitscalculated &&
          blok.howitscalculated.map((nestedBlok: SbBlokData) => (
            <StoryblokServerComponent blok={nestedBlok} key={nestedBlok._uid} />
          ))
        }
        disclaimer={
          blok.disclaimer &&
          blok.disclaimer.map((nestedBlok: SbBlokData) => (
            <StoryblokServerComponent blok={nestedBlok} key={nestedBlok._uid} />
          ))
        }
      />
    </div>
  )
}

export default Calculator
